import React, { useState } from 'react';
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Card,
  Button,
  Tabs,
  AutoComplete,
  message
} from 'antd';
import { Navigate, useParams } from "react-router-dom"
import { QuestionCircleOutlined } from '@ant-design/icons';
import axios from '../../services/axios'
import SelectSearchInput from '../../utils/components/selectSearchInput';

const { Option } = Select;
const { TabPane } = Tabs;
const residences = [
  {
    value: 'zhejiang',
    label: 'Zhejiang',
    children: [
      {
        value: 'hangzhou',
        label: 'Hangzhou',
        children: [
          {
            value: 'xihu',
            label: 'West Lake',
          },
        ],
      },
    ],
  },
  {
    value: 'jiangsu',
    label: 'Jiangsu',
    children: [
      {
        value: 'nanjing',
        label: 'Nanjing',
        children: [
          {
            value: 'zhonghuamen',
            label: 'Zhong Hua Men',
          },
        ],
      },
    ],
  },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const Forms = () => {
  const [form] = Form.useForm();
  const [roles, setRoles] = React.useState([])
  const [redirect, setRedirect] = React.useState(false)
  const [loadint, setLoading] = React.useState(false)
  const { id }: any = useParams();

  React.useEffect(() => {
    getRoles()
    if (id) {
      getSingleUser(id)
    }
  }, [])

  const getSingleUser = (id: number) => {
    axios.get(`/users/${id}`)
      .then(response => {
        const user = response.data;
        form.setFieldsValue({
          ...user,
          roles: user.roles[0] ? user.roles[0].id : undefined,
        });
      })
      .catch(error => {
        console.log(error);
        message.error("Impossible de charger cet utilisateur");
      });
  }

  const onFinish = (values: any) => {
    setLoading(true);

    const request = id
      ? axios.post(`/register/edit/${id}`, values)
      : axios.post('/registers/new', values);

    request
      .then(function (response) {
        setRedirect(true)
        setLoading(false);
        message.success(id ? "Utilisateur modifié avec succès" : "L'utilisateur ajouté avec succé");
        form.resetFields();
      })
      .catch(function (error) {
        console.log(error);
        message.error(error.response?.data?.error || "Echec de l'enregistrement");
        setLoading(false);
      });
  };

  const [autoCompleteResult, setAutoCompleteResult] = useState<string[]>([]);

  const onWebsiteChange = (value: string) => {
    if (!value) {
      setAutoCompleteResult([]);
    } else {
      setAutoCompleteResult(['.com', '.org', '.net'].map(domain => `${value}${domain}`));
    }
  };

  const getRoles = () => {
    axios.get('/roles')
      .then(response => {
        setRoles(response.data);
        // setLoading(false)
      });
  }

  const onSearch = (val: any) => {
    
  }

  const onChange = (name: string, value: any) => {
    form.setFieldsValue({ [name]: value })
  }

  const websiteOptions = autoCompleteResult.map(website => ({
    label: website,
    value: website,
  }));

  if (redirect) {
    return <Navigate to="/utilisateurs" replace />;
  }

  return (
    <Tabs defaultActiveKey="1" >
      <TabPane tab="Information de connexion" key="1">
        <Row justify="center">
          <Col xs={24} sm={22} md={18} lg={16} xl={16} offset={0}>
            <Card size="small" title={id ? "Modifier l'utilisateur" : "Ajouter un nouveau utilisateur"} >
              <Form
                {...formItemLayout}
                form={form}
                name="register"
                onFinish={onFinish}

                scrollToFirstError
              >

                <Form.Item
                  name="prenom"
                  label="Prenom"
                  rules={[
                    {
                      required: true,
                      message: 'Ce champ est obligatoire!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="nom"
                  label="Nom"
                  rules={[
                    {
                      required: true,
                      message: 'Ce champ est obligatoire!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="username"
                  label="Idetnetifant(login)"
                  rules={[
                    {
                      required: true,
                      message: 'Ce champ est obligatoire!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Mot de passe"
                  extra={id ? "Laisser vide pour ne pas changer le mot de passe" : undefined}
                  rules={[
                    {
                      required: !id,
                      message: 'ce champ est obligatoire!',
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="confirm"
                  label="Confirme mot de passe"
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: !id,
                      message: 'Ce champ est obligatoire!',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject('Les deux mots de passe que vous avez entrés ne correspondent pas!');
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="telephone"
                  label="Numéro de telephone"
                  rules={[
                    {
                      required: true,
                      message: 'Ce champ est obligatoire!',
                    },
                  ]}
                >
                  <Input placeholder="telephone" />
                </Form.Item>
                <Form.Item name='roles' label="Roles" rules={[{ required: true }]}>

                  <SelectSearchInput
                    onChange={(v) => onChange('role', v)}
                    data={roles}
                    label='display_name'
                    valueLabel='id'
                    onSearch={(value) => onSearch(value)}
                    placeholder="sectionnez le role "
                    disabled={!!id}
                  />
                </Form.Item>

                <Form.Item {...tailFormItemLayout}>
                  <Button type="primary" htmlType="submit" loading={loadint}>
                    {id ? 'Modifier' : 'Enregistrer'}
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </TabPane>
    </Tabs>

  );
};
export default Forms